<template>
  <section
    class="filter tw-relative tw-flex tw-items-center"
    :class="[showFilterOptions ? 'tw-z-20' : null]"
  >
    <transition name="fade-transform" mode="out-in">
      <FilterModal
        title="Filter Transactions"
        v-if="showFilterOptions"
        @close="showFilterOptions = false"
        :show="showFilterOptions"
        class="acknowledge__modal"
        :showBackButton="false"
      >
        <template v-slot:content>
          <div
            class="tw-max-w-[378px] tw-w-full tw-mx-auto tw-mt-6 tw-border-b tw-mb-5 tw-border-[#F0F4FD] tw-pr-[25px]"
          >
            <h2 class="tw-text-secondary tw-font-bold tw-text-lg tw-mb-3">
              By Status
            </h2>
            <label
              :for="option"
              class="tw-flex tw-items-center tw-justify-between tw-mb-4 tw-cursor-pointer"
              v-for="(option, index) in filterOptions"
              :key="option + index"
            >
              <span
                class="tw-flex tw-items-center tw-rounded tw-h-9 tw-px-[10px] tw-py-[2px]"
                :class="option.toLowerCase()"
                >{{ option }}</span
              >
              <input
                class="tw-h-6 tw-w-6"
                v-model="filterValue"
                type="radio"
                name="status"
                :value="option"
                :id="option"
              />
            </label>
          </div>
          <div class="tw-max-w-[378px] tw-w-full tw-mx-auto tw-mt-5">
            <h2 class="tw-text-secondary tw-font-bold tw-text-lg tw-mb-3">
              By Date
            </h2>
            <InputFieldLabel label="Start Date" :inputActive="!!startDate">
              <Datepicker
                class="tw-mb-6"
                placeholder="Start Date"
                :upperLimit="new Date()"
                :enableTimePicker="false"
                @cleared="startDate = new Date(undefined)"
                v-model="startDate"
              ></Datepicker>
            </InputFieldLabel>
            <InputFieldLabel
              label="End Date"
              :inputActive="!!endDate"
              v-if="startDate"
            >
              <Datepicker
                placeholder="End Date"
                :lowerLimit="startDate"
                :upperLimit="new Date()"
                :enableTimePicker="false"
                @cleared="endDate = new Date(undefined)"
                v-model="endDate"
              ></Datepicker>
            </InputFieldLabel>
          </div>
          <div
            class="tw-flex tw-justify-between tw-items-center tw-mt-[50px] tw-w-full tw-mx-auto tw-max-w-[378px]"
          >
            <button
              @click="clearOptions"
              class="tw-w-full tw-h-[50px] tw-rounded tw-max-w-[180px] tw-bg-[#E6EDFF] tw-text-[#06206B]"
            >
              Clear
            </button>
            <div class="tw-w-full tw-max-w-[180px]">
              <CustomButton
                title="Filter"
                @click="processFilterSelection"
                :disabled="
                  (!filterValue && !isDateValid) ||
                  (!isDateValid && !isFilteredByStatus)
                "
              />
            </div>
          </div>
        </template>
      </FilterModal>
    </transition>
    <button
      class="tw-w-6 tw-h-6 md:tw-mr-1 tw-bg-white filter__button filter__button--default tw-flex tw-gap-x-2 tw-items-center tw-text-[#949DBC] tw-tracking-[-0.12px] tw-text-sm hover:tw-text-gray-dark3 tw-justify-center"
      @click="$emit('filter-click')"
    >
      <img
        class="tw-h-4 tw-w-4 tw-mr-1"
        src="@/assets/img/filter.svg"
        alt="filter icon"
      />
      Filter
    </button>
  </section>
</template>

<script>
  import FilterModal from "@/components/general/sidemodal/SideModal";
import Datepicker from "vue3-datepicker";
import CustomButton from "../general/BtnComponent";
import Checkbox from "./Checkbox";
import InputFieldLabel from "./InputFieldLabel";
  export default {
    name: "Filter",
    emits: ["filter-click", "filter-selected"],
    data() {
      return {
        filterValue: "",
        startDate: new Date(undefined),
        endDate: new Date(undefined),
        filterTypes: [
          {
            name: "Status",
            value: "status",
          },
          {
            name: "Date",
            value: "updatedAt",
          },
        ],
        filter: "",
      };
    },
    props: {
      showFilterOptions: {
        type: Boolean,
        required: true,
        default: () => false,
      },
      filterOptions: {
        type: Array,
        required: true,
      },
    },
    components: {
      Checkbox,
      Datepicker,
      CustomButton,
      FilterModal,
      InputFieldLabel,
    },
    watch: {
      filterValue(val) {
        if (val && val.length > 0) {
          this.startDate = new Date(undefined);
          this.endDate = new Date(undefined);
        }
      },
      startDate(val) {
        if (String(val) !== "Invalid Date") {
          this.filterValue = "";
        }
      },
      endDate(val) {
        if (String(val) !== "Invalid Date") {
          this.filterValue = "";
        }
      },
    },
    computed: {
      isFilteredByStatus() {
        return !!this.filterValue;
      },
      isDateValid() {
        return (
          String(this.startDate) !== "Invalid Date" &&
          String(this.endDate) !== "Invalid Date"
        );
      },
    },
    methods: {
      clearOptions() {
        this.filterValue = "All";
        this.$emit("filter-selected", {
          value: "",
        });
        setTimeout(() => {
          this.$emit("filter-click");
        }, 1000);
      },
      processFilterSelection() {
        if (this.isFilteredByStatus) {
          this.$emit("filter-selected", {
            value: { status: this.filterValue },
            type: 'status'
          });
        } else {
          this.$emit("filter-selected", {
            value: {
              from: new Date(this.startDate).toISOString(),
              to: new Date(this.endDate).toISOString(),
            },
            type: 'date'
          });
        }
        setTimeout(() => {
          this.$emit("filter-click");
        }, 100);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .filter {
    z-index: 20;
    &-options__div {
      background: #ffffff;
      box-shadow: 0px 2px 4px rgba(44, 73, 137, 0.3);
      border-radius: 4px;
      width: 290px;
      top: 0;
      right: 0;
    }
    &-close__button {
      right: 16px;
      top: 16px;
    }
    &__button {
      &--default {
        border: 1px solid #d0d5e0;
        box-sizing: border-box;
        border-radius: 4px;
        width: 112px;
        height: 40px;
      }
      &:hover {
        background-color: #fff;
      }
    }
  }

  .completed {
    background-color: rgba(39, 174, 96, 0.1);
    color: #27ae60;
  }

  .pending {
    background-color: rgba(243, 139, 0, 0.1);
    color: #f38b00;
  }

  .failed {
    background-color: rgba(219, 67, 67, 0.1);
    color: #db4343;
  }
</style>
